import React, { useState } from 'react';
import { Card, CardContent, Typography, Box, Button } from '@mui/material';
import { useQuery } from 'react-query';
import axiosClient from '../../../../../../../lib/axios';
import { TableSimples } from '../../../../../../../components/BasicComponents/DisplayDados/TableSimples';
import { IDataRefUltimasCompras } from '../../../../../../../types/api/estoque/detalhar-referencia-ultimas-compras';
import UltimasComprasSkeleton from './UltimasComprasSkeleton';
import DialogUltimasCompras from './DialogUltimasCompras';
import moment from 'moment';

const CardUltimasCompras: React.FC<ICardUltimasComprasProps> = ({ produtoId }) => {

    const perPage = 5

    const [openDialog, setOpenDialog] = useState(false)

    const { data, isLoading } = useQuery({
        queryKey: ['ultimas-compras', produtoId],
        queryFn: () => axiosClient.get(`/estoque/detalhar-referencia-ultimas-compras`, {
            params: {
                produto_id: produtoId,
                per_page: perPage
            }
        }),
        cacheTime: 0,
    })

    const ultimasCompras: IDataRefUltimasCompras[] = data?.data.data || []
    const carregando = isLoading || !data

    const headers = [
        { label: 'Loja', numeric: false },
        { label: 'Data', numeric: true }
    ];

    const rows = ultimasCompras.map(compra => ({
        columns: [
            { value: compra.nome_loja, numeric: false },
            { value: moment(compra.data_movimento).format('DD/MM/YYYY'), numeric: true },
        ]
    }));

    if (carregando) {
        return <UltimasComprasSkeleton />
    }

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" mb={2}>
                    Últimas compras
                </Typography>

                {
                    ultimasCompras.length === 0 && (
                        <Typography variant="body1" color="text.secondary">
                            Nenhuma compra encontrada
                        </Typography>
                    )
                }

                {
                    ultimasCompras.length > 0 && (
                        <TableSimples
                            headers={headers}
                            rows={rows}
                            total={
                                (data?.data.total - perPage) > 0 
                                ? {
                                    label: '',
                                    value: `+ ${data?.data.total - perPage} registro(s)`,
                                    monetary: false
                                }
                                : undefined
                            }
                        />
                    )
                }

                <Box display="flex" justifyContent="flex-end" mt={1}>
                    <Button
                        variant="outlined"
                        size="small"
                        disabled={ultimasCompras.length === 0}
                        onClick={() => setOpenDialog(true)}
                    >
                        Ver mais
                    </Button>
                </Box>
            </CardContent>

            {
                openDialog && (
                    <DialogUltimasCompras
                        {...{ produtoId }}
                        open={openDialog}
                        onClose={() => setOpenDialog(false)}
                    />
                )
            }
        </Card>
    );
};

export default CardUltimasCompras;

interface ICardUltimasComprasProps {
    produtoId: number;
}